__turbopack_context__.v({
  "shareBtn": "ShareProfileButton-module__Qh2tSa__shareBtn",
  "shareWrap": "ShareProfileButton-module__Qh2tSa__shareWrap",
  "tooltip": "ShareProfileButton-module__Qh2tSa__tooltip",
  "tooltipDone": "ShareProfileButton-module__Qh2tSa__tooltipDone",
  "tooltipError": "ShareProfileButton-module__Qh2tSa__tooltipError",
  "tooltipPinned": "ShareProfileButton-module__Qh2tSa__tooltipPinned",
});
